import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export enum ShowSlotsBehavior {
  All = 'all',
  Available = 'available',
}

export const DEFAULT_DISPLAYED_SLOTS_LIMIT = 15
export const MIN_DISPLAYED_SLOTS_LIMIT = 1
export const MAX_DISPLAYED_SLOTS_LIMIT = 100

export const clampDisplayedSlotsLimit = (value: unknown): number => {
  const parsedValue = Number(value)

  if (!Number.isFinite(parsedValue)) {
    return DEFAULT_DISPLAYED_SLOTS_LIMIT
  }

  return Math.min(
    MAX_DISPLAYED_SLOTS_LIMIT,
    Math.max(MIN_DISPLAYED_SLOTS_LIMIT, Math.round(parsedValue)),
  )
}

export type DisplaySettingsParams = {
  showTitle: SettingsParamType.Boolean
  showDescription: SettingsParamType.Boolean
  showAreasDescription: SettingsParamType.Boolean
  showSlotsBehavior: SettingsParamType.String
  limitDisplayedSlots: SettingsParamType.Boolean
  displayedSlotsLimit: SettingsParamType.Number
  showBreadcrumbs: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS: Record<keyof DisplaySettingsParams, any> = {
  showTitle: true,
  showDescription: true,
  showAreasDescription: true,
  showSlotsBehavior: ShowSlotsBehavior.All,
  limitDisplayedSlots: true,
  displayedSlotsLimit: DEFAULT_DISPLAYED_SLOTS_LIMIT,
  showBreadcrumbs: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showTitle,
  },
  showDescription: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showDescription,
  },
  showAreasDescription: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showAreasDescription,
  },
  showSlotsBehavior: {
    type: SettingsParamType.String,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showSlotsBehavior,
  },
  limitDisplayedSlots: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.limitDisplayedSlots,
  },
  displayedSlotsLimit: {
    type: SettingsParamType.Number,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.displayedSlotsLimit,
  },
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
  },
})
